import { useState } from 'react'
import Modal from './Modal'
import { LoginForm } from '../pages/Login'
import { RegisterForm } from '../pages/Register'

interface RegistrationPromptModalProps {
  isOpen: boolean
  onClose: () => void
}

export default function RegistrationPromptModal({ isOpen, onClose }: RegistrationPromptModalProps) {
  const [showRegister, setShowRegister] = useState(false)
  const [showLogin, setShowLogin] = useState(false)

  const handleRegisterSuccess = () => {
    setShowRegister(false)
    onClose()
  }

  const handleLoginSuccess = () => {
    setShowLogin(false)
    onClose()
  }


  if (showRegister) {
    return (
      <Modal isOpen={isOpen} onClose={() => setShowRegister(false)} title="Create your account">
        <RegisterForm onSuccess={handleRegisterSuccess} />
      </Modal>
    )
  }

  if (showLogin) {
    return (
      <Modal isOpen={isOpen} onClose={() => setShowLogin(false)} title="Welcome back">
        <LoginForm onSuccess={handleLoginSuccess} />
      </Modal>
    )
  }


  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Ready for more dates?">
      <div className="text-center">
        <div className="text-6xl mb-4">🎲</div>
        <h3 className="text-xl font-semibold text-black mb-2">
          You've rolled 3 amazing dates!
        </h3>
        <p className="text-black/70 mb-6">
          To roll more dates, don't worry - it's FREE! Just register and sign in to unlock unlimited date ideas.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button 
            onClick={() => setShowRegister(true)}
            className="btn-primary px-6 py-3"
          >
            Sign Up (Free)
          </button>
          <button 
            onClick={() => setShowLogin(true)}
            className="btn-nav px-6 py-3"
          >
            Sign In
          </button>
        </div>
        <p className="text-sm text-black/50 mt-4">
          No credit card required • Takes 30 seconds
        </p>
      </div>
    </Modal>
  )
}
